module.exports = __webpack_public_path__ + "static/media/apartment21.845b6085.jpg";